import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import messageHandler from 'utils/messageHandler';

const projectsSlice = createSlice({
  name: 'projects',
  initialState: {
    branchOfficeProjects: { list: [], length: 0 },
    sharedProjects: { list: [], length: 0, neighborhoods: [] }
  },
  reducers: {
    setProjectsArray: (state, { payload }) => {
      state.branchOfficeProjects.list = payload.response;
      state.branchOfficeProjects.length = payload.length;
      state.branchOfficeProjects.neighborhoods = payload.neighborhoods;
    },
    setSharedProjects: (state, { payload }) => {
      state.sharedProjects.list = payload.result;
      state.sharedProjects.length = payload.allProjectsLength;
      state.sharedProjects.neighborhoods = payload.neighborhoods;
      state.sharedProjects.realEstates = payload.realEstates;
    }
  }
});

export const { setProjectsArray, setSharedProjects } = projectsSlice.actions;

export const getProjectsByFilters =
  (filtersAndSort, page, propsLimit, searchProp, address) => async dispatch => {
    //Retorna todas las props en un objeto por oficina

    if (filtersAndSort.branchOffices[0]) {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}/projects/branch-office?offset=${
          page - 1
        }&limit=${propsLimit}&field=${searchProp}&address=${address}`,
        filtersAndSort
      );

      const data = {
        response: response.data.result,
        length: response.data.allProjectsLength,
        neighborhoods: response.data.neighborhoods
      };
      dispatch(setProjectsArray(data));
    }
  };

export const getSharedProjects =
  (
    filtersAndSort,
    page,
    propsLimit,
    searchProp,
    address,
    excludedRealEstateId
  ) =>
  async dispatch => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_SERVER}/projects/shared?offset=${
        page - 1
      }&limit=${propsLimit}&field=${searchProp}&address=${address}`,
      { ...filtersAndSort, excludedRealEstateId }
    );

    dispatch(setSharedProjects(data));
  };

export const getProjectById = id => async () => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_SERVER}/projects/${id}?admin=true`
    );

    return data;
  } catch (e) {
    console.log(e);
  }
};

export const createProject = info => async () => {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_SERVER}/projects`,
      info
    );

    return data.projectId;
  } catch (e) {
    console.log(e);
    messageHandler('error', e.response.data.message);
  }
};

export const updateProject = (project, id) => async () => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_SERVER}/projects/${id}`,
      project
    );

    return response;
  } catch (e) {
    return e.response;
  }
};

export const uploadImageProject = (projectId, formData) => async () => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_SERVER}/projects/upload-image/${projectId}`,
      formData
    );

    return response;
  } catch (e) {
    messageHandler('error', e.response.data.message);
    return e.response;
  }
};

export const editImageProject = (id, formData) => async () => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_SERVER}/projects/edit-image/${id}`,
      formData
    );

    return response;
  } catch (e) {
    messageHandler('error', e.response.data.message);
    return e.response;
  }
};

export const setImagesOrderProject = (id, filesOrder, accessor) => async () => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_SERVER}/projects/set-images-order/${id}`,
      {
        filesOrder,
        accessor
      }
    );

    return response.status;
  } catch (e) {
    messageHandler('error', 'No se pudo cambiar el orden de las imágenes');
    return e.response.status;
  }
};

export const imageDeleteProject =
  (propertyId, fileName, accessor) => async () => {
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_SERVER}/projects/delete-image/${propertyId}`,
        {
          filename: fileName,
          accessor
        }
      );

      return response;
    } catch (e) {
      messageHandler('error', e.response.data.message);
      return e.response;
    }
  };

export const setProjectActive = id => async () => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_SERVER}/projects/publish/${id}`,
      {
        status: 'published'
      }
    );

    messageHandler('success', response.data.message);
    return response.status;
  } catch (e) {
    messageHandler('error', e.response.data.message);
    return e.response.status;
  }
};

export const copyProject = id => async () => {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_SERVER}/projects/copy/${id}`
    );

    messageHandler('success', data.message);
    return data.newProject._id;
  } catch (e) {
    messageHandler('error', e.response.data.message);
    return e.response.status;
  }
};

export const changeShareProject =
  (id, percent, active, handleClose) => async () => {
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_SERVER}/projects/change-share/${id}`,
        {
          percent: percent,
          active: active
        }
      );

      handleClose && handleClose();

      return response;
    } catch (e) {
      return e.response;
    }
  };

export const changeStatusProject = (id, status) => async () => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_SERVER}/projects/${id}`,
      {
        status: status
      }
    );

    messageHandler('success', response.data.message);
    return response.status;
  } catch (e) {
    messageHandler('error', e.response.data.message);
    return e.response.status;
  }
};

export const changeMultipleStatusProject = (id, status) => async () => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_SERVER}/projects/${id}`,
      {
        status: status
      }
    );
    return response;
  } catch (e) {
    return e.response;
  }
};

export const deleteProject = id => async () => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_SERVER}/projects/logical/${id}`
    );

    messageHandler('success', 'Emprendimiento eliminado correctamente');
    return response.status;
  } catch (e) {
    messageHandler('error', e.response.data.message);
    return e.response.status;
  }
};

export const deleteMultipleProject = id => async () => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_SERVER}/projects/logical/${id}`
    );

    return response.status;
  } catch (e) {
    return e.response.status;
  }
};

export const physicDeleteProject = id => async () => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_SERVER}/projects/phisical/${id}`
    );

    messageHandler('success', response.data.message);
  } catch (e) {
    messageHandler('error', e.response.data.message);
  }
};

export default projectsSlice.reducer;
